var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword as fbSignInWithEmail, createUserWithEmailAndPassword, signOut as fbSignOut, GoogleAuthProvider, signInWithPopup, signInWithCredential, OAuthProvider, indexedDBLocalPersistence, initializeAuth } from 'firebase/auth';
import { Capacitor } from '@capacitor/core';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { getFirestore, collection, doc, query, where, orderBy, limit, startAfter, endBefore, getDoc, getDocs, setDoc, updateDoc, deleteDoc, onSnapshot } from 'firebase/firestore';
/**
 * Firebase configuration
 */
var firebaseConfig = {
    apiKey: "AIzaSyC015CU--zQTYRuPwnQrMLXQgClm2RtHG4",
    authDomain: "comini-ripple-dev.firebaseapp.com",
    projectId: "comini-ripple-dev",
    storageBucket: "comini-ripple-dev.firebasestorage.app",
    messagingSenderId: "374593408864",
    appId: "1:374593408864:web:f7bd8d15af8865979bd805",
};
/**
 * Initialize Firebase with proper auth configuration for web/native platforms
 */
var FirebaseService = /** @class */ (function () {
    function FirebaseService() {
        // Initialize Firebase
        this.app = initializeApp(firebaseConfig);
        // Initialize auth with proper persistence for platform
        this._auth = this.getFirebaseAuth();
        this._firestore = getFirestore(this.app);
        // Create the services object that will be shared with all MFEs
        this._services = {
            // Core
            app: this.app,
            // Auth services and functions
            auth: this._auth,
            onAuthStateChanged: onAuthStateChanged,
            signInWithEmailAndPassword: fbSignInWithEmail,
            createUserWithEmailAndPassword: createUserWithEmailAndPassword,
            signOut: this.signOut.bind(this),
            GoogleAuthProvider: GoogleAuthProvider,
            signInWithPopup: signInWithPopup,
            signInWithGoogle: this.signInWithGoogle.bind(this),
            signInWithApple: this.signInWithApple.bind(this),
            // signInWithFacebook: this.signInWithFacebook.bind(this),
            // signInWithTwitter: this.signInWithTwitter.bind(this),
            // Firestore services and functions
            firestore: this._firestore,
            collection: collection,
            doc: doc,
            query: query,
            where: where,
            orderBy: orderBy,
            limit: limit,
            startAfter: startAfter,
            endBefore: endBefore,
            getDoc: getDoc,
            getDocs: getDocs,
            setDoc: setDoc,
            updateDoc: updateDoc,
            deleteDoc: deleteDoc,
            onSnapshot: onSnapshot
        };
        // Make available globally if needed
        window.firebaseServices = this._services;
    }
    /**
     * Initialize auth with the appropriate configuration based on platform
     */
    FirebaseService.prototype.getFirebaseAuth = function () {
        if (Capacitor.isNativePlatform()) {
            return initializeAuth(this.app, {
                persistence: indexedDBLocalPersistence,
            });
        }
        else {
            return getAuth(this.app);
        }
    };
    /**
     * Sign in with Google across platforms
     */
    FirebaseService.prototype.signInWithGoogle = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, credential, userCredential, error_1, provider, userCredential, error_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!Capacitor.isNativePlatform()) return [3 /*break*/, 6];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, FirebaseAuthentication.signInWithGoogle()];
                    case 2:
                        result = _b.sent();
                        credential = GoogleAuthProvider.credential((_a = result.credential) === null || _a === void 0 ? void 0 : _a.idToken);
                        return [4 /*yield*/, signInWithCredential(this._auth, credential)];
                    case 3:
                        userCredential = _b.sent();
                        return [2 /*return*/, userCredential.user];
                    case 4:
                        error_1 = _b.sent();
                        console.error('Google sign-in failed:', error_1);
                        return [2 /*return*/, null];
                    case 5: return [3 /*break*/, 9];
                    case 6:
                        _b.trys.push([6, 8, , 9]);
                        provider = new GoogleAuthProvider();
                        return [4 /*yield*/, signInWithPopup(this._auth, provider)];
                    case 7:
                        userCredential = _b.sent();
                        return [2 /*return*/, userCredential.user];
                    case 8:
                        error_2 = _b.sent();
                        console.error('Google sign-in failed:', error_2);
                        return [2 /*return*/, null];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sign in with Apple across platforms
     */
    FirebaseService.prototype.signInWithApple = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, provider, credential, userCredential, error_3, provider, userCredential, error_4;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!Capacitor.isNativePlatform()) return [3 /*break*/, 6];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, FirebaseAuthentication.signInWithApple({
                                skipNativeAuth: true,
                            })];
                    case 2:
                        result = _c.sent();
                        provider = new OAuthProvider('apple.com');
                        credential = provider.credential({
                            idToken: (_a = result.credential) === null || _a === void 0 ? void 0 : _a.idToken,
                            rawNonce: (_b = result.credential) === null || _b === void 0 ? void 0 : _b.nonce,
                        });
                        return [4 /*yield*/, signInWithCredential(this._auth, credential)];
                    case 3:
                        userCredential = _c.sent();
                        return [2 /*return*/, userCredential.user];
                    case 4:
                        error_3 = _c.sent();
                        console.error('Apple sign-in failed:', error_3);
                        return [2 /*return*/, null];
                    case 5: return [3 /*break*/, 9];
                    case 6:
                        _c.trys.push([6, 8, , 9]);
                        provider = new OAuthProvider('apple.com');
                        return [4 /*yield*/, signInWithPopup(this._auth, provider)];
                    case 7:
                        userCredential = _c.sent();
                        return [2 /*return*/, userCredential.user];
                    case 8:
                        error_4 = _c.sent();
                        console.error('Apple sign-in failed:', error_4);
                        return [2 /*return*/, null];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sign in with Facebook across platforms
     */
    // private async signInWithFacebook(): Promise<User | null> {
    //   if (Capacitor.isNativePlatform()) {
    //     try {
    //       // 1. Create credentials on the native layer
    //       const result = await FirebaseAuthentication.signInWithFacebook();
    //       // 2. Sign in on the web layer using the access token
    //       const credential = FacebookAuthProvider.credential(
    //         result.credential?.accessToken,
    //       );
    //       const userCredential = await signInWithCredential(this._auth, credential);
    //       return userCredential.user;
    //     } catch (error) {
    //       console.error('Facebook sign-in failed:', error);
    //       return null;
    //     }
    //   } else {
    //     // Web implementation
    //     try {
    //       const provider = new FacebookAuthProvider();
    //       const userCredential = await signInWithPopup(this._auth, provider);
    //       return userCredential.user;
    //     } catch (error) {
    //       console.error('Facebook sign-in failed:', error);
    //       return null;
    //     }
    //   }
    // }
    /**
     * Sign in with Twitter across platforms
     */
    // private async signInWithTwitter(): Promise<User | null> {
    //   if (Capacitor.isNativePlatform()) {
    //     try {
    //       // Twitter works on iOS only with skipNativeAuth=false
    //       const result = await FirebaseAuthentication.signInWithTwitter({
    //         skipNativeAuth: false,
    //       });
    //       const credential = TwitterAuthProvider.credential(
    //         result.credential?.accessToken,
    //         result.credential?.secret,
    //       );
    //       const userCredential = await signInWithCredential(this._auth, credential);
    //       return userCredential.user;
    //     } catch (error) {
    //       console.error('Twitter sign-in failed:', error);
    //       return null;
    //     }
    //   } else {
    //     // Web implementation
    //     try {
    //       const provider = new TwitterAuthProvider();
    //       const userCredential = await signInWithPopup(this._auth, provider);
    //       return userCredential.user;
    //     } catch (error) {
    //       console.error('Twitter sign-in failed:', error);
    //       return null;
    //     }
    //   }
    // }
    /**
     * Sign out across platforms
     */
    FirebaseService.prototype.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!Capacitor.isNativePlatform()) return [3 /*break*/, 2];
                        // Sign out on both layers
                        return [4 /*yield*/, FirebaseAuthentication.signOut()];
                    case 1:
                        // Sign out on both layers
                        _a.sent();
                        _a.label = 2;
                    case 2: 
                    // Always sign out on web layer
                    return [4 /*yield*/, fbSignOut(this._auth)];
                    case 3:
                        // Always sign out on web layer
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get the singleton instance of FirebaseService
     */
    FirebaseService.getInstance = function () {
        if (!FirebaseService.instance) {
            FirebaseService.instance = new FirebaseService();
        }
        return FirebaseService.instance;
    };
    Object.defineProperty(FirebaseService.prototype, "services", {
        /**
         * Get all Firebase services
         */
        get: function () {
            return this._services;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseService.prototype, "auth", {
        /**
         * Get auth instance
         */
        get: function () {
            return this._auth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseService.prototype, "firestore", {
        /**
         * Get firestore instance
         */
        get: function () {
            return this._firestore;
        },
        enumerable: false,
        configurable: true
    });
    return FirebaseService;
}());
// Initialize the service
var firebaseService = FirebaseService.getInstance();
// Export the services and instances
export var firebaseServices = firebaseService.services;
export var firebaseAuth = firebaseService.auth;
export var firestoreDb = firebaseService.firestore;
export default firebaseService;
